import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    // localStorage.setItem('serverRoot', 'http://localhost:7000');
    // localStorage.setItem('serverRoot', 'http://95.179.238.195:7000');
    localStorage.setItem('serverRoot', 'https://twigaprime.gocongo.cd:7000');
    translate.setDefaultLang('en');
  }
}
